module.exports = __webpack_public_path__ + "static/media/45245_557056477661944_424704302_n.2b19f84f.jpg";